import { PaymentAmountWrapper } from '../PaymentAmountWrapper';
import { PaymentStatusWrapper } from '../PaymentStatusWrapper';

// Nothing is billed monthly; the accrued interest is surfaced in the payment-form notification
export const InterestDueAtPayoffHeader = () => (
  <>
    <PaymentStatusWrapper className="u-bold">Amount Due</PaymentStatusWrapper>
    <PaymentAmountWrapper amount={0} />
  </>
);
